import { makeStyles } from '@mui/styles';
import FileUpload from 'apollo-react/components/FileUpload';
import Loader from 'apollo-react/components/Loader';
import Typography from 'apollo-react/components/Typography';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useTranslation } from '../../../custom-hooks/useTranslation';
import { setImportStep, uploadAppMigrationFile } from '../../actions/import.actions';
import {
  ALLOWED_IMPORT_TYPES,
  IMPORT_STEPS,
  UPLOAD_ERROR_MESSAGE,
} from '../../constants/import.constants';
import { getImportProp } from '../../selectors/import.selectors';
import InfoBlock from '../common/InfoBlock';

const useStyles = makeStyles({
  errorContainer: { marginTop: 20 },
  errorMessage: {
    color: 'red',
    textAlign: 'center',
  },
});

export const UploadImportFile = ({ selectedFiles, setSelectedFiles, importKey }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const [uploadErrorMessage, setUploadErrorMessage] = useState('');

  const isLoading = useSelector(getImportProp(importKey, 'isLoading'));
  const importStep = useSelector(getImportProp(importKey, 'importStep'));

  useEffect(
    () => () => {
      setUploadErrorMessage([]);
    },
    [setSelectedFiles]
  );

  const handleUpload = ([file]) => {
    setUploadErrorMessage('');
    const fileType = _.last(file.name.split('.'));

    if (!ALLOWED_IMPORT_TYPES.includes(fileType)) {
      setUploadErrorMessage(UPLOAD_ERROR_MESSAGE);
      return;
    }

    dispatch(setImportStep(IMPORT_STEPS.UPLOAD_FILE, importKey));
    dispatch(uploadAppMigrationFile(file, { importKey }));
    setSelectedFiles([file]);
  };

  const handleDelete = () => {
    setSelectedFiles([]);
    dispatch(setImportStep(IMPORT_STEPS.INITIAL_STEP, importKey));
  };

  return (
    <div style={{ height: isLoading && 135 }}>
      {!isLoading && importStep < IMPORT_STEPS.START_IMPORT && (
        <FileUpload
          maxItems={1}
          fullWidth
          value={selectedFiles}
          onFileDelete={handleDelete}
          onUpload={handleUpload}
          dropAreaLabels={{
            activeText: translateString('Drop here to upload!'),
            browseLinkText: translateString('browse').toLowerCase(),
            defaultText: translateString('Drag a zip file here or '),
            hoverText: translateString('Click to browse'),
            maxText: translateString('You can import only one file'),
          }}
        />
      )}
      {uploadErrorMessage && (
        <div className={classes.errorContainer} style={{ height: isLoading && 135 }}>
          <InfoBlock type="warning">
            <Typography className={classes.errorMessage}>
              {translateString(uploadErrorMessage)}
            </Typography>
          </InfoBlock>
        </div>
      )}
      {isLoading && <Loader isInner />}
    </div>
  );
};
